module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "c"
  }, [_vm._v("Table of Contents")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/Text/Section0003.htm#daudet"
    }
  }, [_vm._v("DAUDET, ALPHONSE")]), _c('br', {
    staticClass: "calibre3"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/OEBPS/Text/Section0003.htm#daudet1"
    }
  }, [_vm._v("Tartarin of Tarascon")]), _c('br', {
    staticClass: "calibre3"
  }), _vm._v(" "), _c('br', {
    staticClass: "calibre3"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/OEBPS/Text/Section0004.htm#day"
    }
  }, [_vm._v("DAY, THOMAS")]), _c('br', {
    staticClass: "calibre3"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/OEBPS/Text/Section0004.htm#day1"
    }
  }, [_vm._v("Sandford and Merton")]), _c('br', {
    staticClass: "calibre3"
  }), _vm._v(" "), _c('br', {
    staticClass: "calibre3"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/OEBPS/Text/Section0005.htm#defoe"
    }
  }, [_vm._v("DEFOE, DANIEL")]), _c('br', {
    staticClass: "calibre3"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/OEBPS/Text/Section0005.htm#defoe1"
    }
  }, [_vm._v("Robinson Crusoe")]), _c('br', {
    staticClass: "calibre3"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/OEBPS/Text/Section0006.htm#defoe2"
    }
  }, [_vm._v("Captain Singleton")]), _c('br', {
    staticClass: "calibre3"
  }), _vm._v(" "), _c('br', {
    staticClass: "calibre3"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/OEBPS/Text/Section0007.htm#dickens"
    }
  }, [_vm._v("DICKENS, CHARLES")]), _c('br', {
    staticClass: "calibre3"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/OEBPS/Text/Section0007.htm#dickens1"
    }
  }, [_vm._v("Barnaby Rudge")]), _c('br', {
    staticClass: "calibre3"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/OEBPS/Text/Section0008.htm#dickens2"
    }
  }, [_vm._v("Bleak House")]), _c('br', {
    staticClass: "calibre3"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/OEBPS/Text/Section0009.htm#dickens3"
    }
  }, [_vm._v("David Copperfield")]), _c('br', {
    staticClass: "calibre3"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/OEBPS/Text/Section0010.htm#dickens4"
    }
  }, [_vm._v("Dombey and Son")]), _c('br', {
    staticClass: "calibre3"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/OEBPS/Text/Section0011.htm#dickens5"
    }
  }, [_vm._v("Great Expectations")]), _c('br', {
    staticClass: "calibre3"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/OEBPS/Text/Section0012.htm#dickens6"
    }
  }, [_vm._v("Hard Times")]), _c('br', {
    staticClass: "calibre3"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/OEBPS/Text/Section0012.htm#dickens7"
    }
  }, [_vm._v("Little Dorrit")]), _c('br', {
    staticClass: "calibre3"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/OEBPS/Text/Section0012.htm#dickens8"
    }
  }, [_vm._v("Martin Chuzzlewit")]), _c('br', {
    staticClass: "calibre3"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/OEBPS/Text/Section0012.htm#dickens9"
    }
  }, [_vm._v("Nicholas Nickleby")]), _c('br', {
    staticClass: "calibre3"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/OEBPS/Text/Section0012.htm#dickens10"
    }
  }, [_vm._v("Oliver Twist")]), _c('br', {
    staticClass: "calibre3"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/OEBPS/Text/Section0012.htm#dickens11"
    }
  }, [_vm._v("Old Curiosity Shop")]), _c('br', {
    staticClass: "calibre3"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/OEBPS/Text/Section0012.htm#dickens12"
    }
  }, [_vm._v("Our Mutual Friend")]), _c('br', {
    staticClass: "calibre3"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/OEBPS/Text/Section0012.htm#dickens13"
    }
  }, [_vm._v("Pickwick Papers")]), _c('br', {
    staticClass: "calibre3"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/OEBPS/Text/Section0012.htm#dickens14"
    }
  }, [_vm._v("Tale of Two Cities")]), _c('br', {
    staticClass: "calibre3"
  }), _vm._v(" "), _c('br', {
    staticClass: "calibre3"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/OEBPS/Text/Section0013.htm#disraeli"
    }
  }, [_vm._v("DISRAELI, BENJAMIN (Earl of Beaconsfield)")]), _c('br', {
    staticClass: "calibre3"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/OEBPS/Text/Section0013.htm#disraeli1"
    }
  }, [_vm._v("Coningsby")]), _c('br', {
    staticClass: "calibre3"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/OEBPS/Text/Section0013.htm#disraeli2"
    }
  }, [_vm._v("Sybil, or The Two Nations")]), _c('br', {
    staticClass: "calibre3"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/OEBPS/Text/Section0013.htm#disraeli3"
    }
  }, [_vm._v("Tancred, or The New Crusade")]), _c('br', {
    staticClass: "calibre3"
  }), _vm._v(" "), _c('br', {
    staticClass: "calibre3"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/OEBPS/Text/Section0013.htm#dumas"
    }
  }, [_vm._v("DUMAS, ALEXANDRE")]), _c('br', {
    staticClass: "calibre3"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/OEBPS/Text/Section0013.htm#dumas1"
    }
  }, [_vm._v("Marguerite de Valois")]), _c('br', {
    staticClass: "calibre3"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/OEBPS/Text/Section0013.htm#dumas2"
    }
  }, [_vm._v("Black Tulip")]), _c('br', {
    staticClass: "calibre3"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/OEBPS/Text/Section0013.htm#dumas3"
    }
  }, [_vm._v("Corsican Brothers")]), _c('br', {
    staticClass: "calibre3"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/OEBPS/Text/Section0013.htm#dumas4"
    }
  }, [_vm._v("Count of Monte Cristo")]), _c('br', {
    staticClass: "calibre3"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/OEBPS/Text/Section0013.htm#dumas5"
    }
  }, [_vm._v("The Three Musketeers")]), _c('br', {
    staticClass: "calibre3"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/OEBPS/Text/Section0013.htm#dumas6"
    }
  }, [_vm._v("Twenty Years After")]), _c('br', {
    staticClass: "calibre3"
  }), _vm._v(" "), _c('br', {
    staticClass: "calibre3"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("A Complete Index of THE WORLD'S GREATEST BOOKS will be found at the end of Volume XX.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b698c552","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/Text/Section0002.vue
// module id = 60
// module chunks = 0